import { render, staticRenderFns } from "./MetadatosAdmin.vue?vue&type=template&id=40200f46&scoped=true&"
import script from "./MetadatosAdmin.vue?vue&type=script&lang=js&"
export * from "./MetadatosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MetadatosAdmin.vue?vue&type=style&index=0&id=40200f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40200f46",
  null
  
)

export default component.exports